import React from 'react'
import Link from 'gatsby-link'
import styles from './Alumni.module.scss'

const Alumni = props => (
	<div className={styles.Alumni}>
		<div className={styles.Alumni__Wrapper}>
			<h2 className="h2">{props.title}</h2>

			<div className={styles.Alumni__Cards}>
				{props.cards.map((card, i) => (
					<div className={styles.Alumni__Card} key={i}>
						<h3 className="h3">{card.title}</h3>
						<p>{card.text.text}</p>
					</div>
				))}
			</div>
			<Link
				className="hoverlink c-white"
				to={props.link.link}
				title={props.link.text}
			>
				{props.link.text}
			</Link>
		</div>
	</div>
)

export default Alumni



// WEBPACK FOOTER //
// ./src/components/Home/Alumni/index.js